import { gql } from 'apollo-boost';

export const saveCallouts = gql`
    mutation SaveCallouts($input: GdSaveCalloutsInput!) {
        saveCallouts(input: $input) {
            calloutIds
            validationResult {
                errors {
                    code
                    params
                    path
                }
                warnings {
                    params
                    path
                    code
                }
            }
        }
    }
`;

export const deleteCallouts = gql`
    mutation DeleteCallouts($input: GdDeleteCalloutsInput!) {
        deleteCallouts(input: $input) {
            calloutIds
            validationResult {
                errors {
                    code
                    params
                    path
                }
                warnings {
                    params
                    path
                    code
                }
            }
        }
    }
`;
